import { render, staticRenderFns } from "./IndexTickets.vue?vue&type=template&id=6a79f5d6"
import script from "./IndexTickets.vue?vue&type=script&lang=js"
export * from "./IndexTickets.vue?vue&type=script&lang=js"
import style0 from "./IndexTickets.vue?vue&type=style&index=0&id=6a79f5d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports